export default {
  PUSH_ATTACHMENT: 'PUSH_ATTACHMENT',
  PUSH_ATTACHMENTS: 'PUSH_ATTACHMENTS',
  REMOVE_ATTACHMENT: 'REMOVE_ATTACHMENT',
  RESET_ATTACHMENT_STATE: 'RESET_ATTACHMENT_STATE',
  SET_ADDING_ATTACHMENT_FOR: 'SET_ADDING_ATTACHMENT_FOR',
  SET_ATTACHMENTS_IS_LOADING: 'SET_ATTACHMENTS_IS_LOADING',
  SET_IS_EDITING_ATTACHMENT: 'SET_IS_EDITING_ATTACHMENT',
};
